import { ArrowBack } from '@mui/icons-material';
import { Box, Dialog, Fade, IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';

import useFormatMessage from '@/hooks/useFormatMessage';

const Transition = forwardRef(function Transition(props, ref) {
  return <Fade ref={ref} {...props} />;
});

export default function MobileSearchSheet({
  open,
  onClose,
  onEntered,
  searchInput,
  dropdown,
  footer,
}) {
  const formatMessage = useFormatMessage();

  return (
    <Dialog
      data-test-subject="mobile-search-sheet"
      open={open}
      onClose={onClose}
      fullScreen
      TransitionComponent={Transition}
      transitionDuration={100}
      TransitionProps={{ onEntered }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          px: 1,
          pt: 2,
          pb: 1,
          borderBottom: '1px solid',
          borderColor: 'grayscale.200',
        }}>
        <IconButton
          aria-label={formatMessage('rental_request_flow_sheet_back')}
          onClick={onClose}
          sx={{ minWidth: 44, minHeight: 44 }}>
          <ArrowBack />
        </IconButton>
        <Box sx={{ flexGrow: 1 }}>{searchInput}</Box>
      </Box>
      {dropdown && (
        <Box sx={{ flexGrow: 1, minHeight: 0, display: 'flex' }}>
          {dropdown}
        </Box>
      )}
      {footer}
    </Dialog>
  );
}

MobileSearchSheet.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onEntered: PropTypes.func,
  searchInput: PropTypes.node.isRequired,
  dropdown: PropTypes.node,
  footer: PropTypes.node,
};
